import * as types from './types'
import storage from '@/Plugins/storage'
import moment from 'moment'

export default {
  [types.SET_PAGER](state, data) {
    switch (data.name) {
      case 'orderBy': {
        state.pager.orderBy = data.value
        break
      }
      case 'sortBy': {
        state.pager.sortBy = data.value
        break
      }
      case 'search': {
        state.pager.search = data.value
        break
      }
      case 'page': {
        state.pager.page = data.value
        break
      }
      case 'pageSize': {
        state.pager.pageSize = data.value
        break
      }
    }
    storage.session.setItem(types.STORE_PAGER, JSON.stringify(state.pager))
  },
  [types.SET_CHECKED](state, data) {
    state.isChecked = false
  },
  [types.RESET_COMPONENTS](state) {
    state.dashboardComponents = []
  },
  [types.RESET_MEDIA](state) {
    state.media = []
  },
  [types.RESET_COMPONENT](state, data) {
    state.dashboardComponent = JSON.parse(
      JSON.stringify(state.defaultComponent)
    )
    state.dashboardComponent.org_id = data.orgId
    state.media = []
  },
  [types.SET_DASHBOARDNAME](state, data) {
    state.dashboardName = null
    if (data !== undefined && data !== null) {
      state.dashboardName = data
    }
  },
  [types.SET_COMPONENTS](state, data) {
    state.dashboardComponents = []
    if (data !== undefined && data !== null) {
      state.dashboardComponents = data.data
      let idx = 0
      state.dashboardComponents.forEach((element) => {
        element.priority = idx
        idx++
      })
      // set up the pager
      state.pager.page = data.current_page
      state.pager.pages = data.last_page
      state.pager.total = data.total
    }
    console.log('Got Dashboard Components', state.dashboardComponents)
  },
  [types.SET_COMPONENT](state, data) {
    state.dashboardComponent = null
    if (data !== undefined && data !== null) {
      let found = state.dashboardComponents.find(
        (x) => parseInt(x.id) === parseInt(data)
      )
      if (found) {
        state.dashboardComponent = JSON.parse(JSON.stringify(found))
      }
    }
  },
  [types.SET_COMPONENT_DATA](state, data) {
    switch (data.name) {
      case 'id': {
        state.dashboardComponent.id = data.value
        break
      }
      case 'name': {
        state.dashboardComponent.name = data.value
        break
      }
      case 'target': {
        state.dashboardComponent.target = parseInt(data.value)
        break
      }
      case 'orgId': {
        state.dashboardComponent.org_id = parseInt(data.value)
        break
      }
    }
    console.log('Updated Component Data', {
      data: data,
      component: state.dashboardComponent,
    })
  },
  [types.RESET_MEDIA_ITEM](state, data) {
    state.mediaItem = JSON.parse(JSON.stringify(state.defaultMedia))
    state.mediaItem.component_id = data.componentId
    state.mediaItem.org_id = data.orgId
    state.mediaItem.start_date = moment().format('YYYY-MM-DD')
    state.mediaItem.end_date = moment().format('YYYY-MM-DD')
  },
  [types.SET_MEDIA](state, data) {
    state.media = []
    if (data !== undefined && data !== null) {
      state.media = data
    }
    console.log('Got Media', state.media)
  },
  [types.SET_MEDIA_ITEM](state, data) {
    state.mediaItem = null
    if (data !== undefined && data !== null) {
      state.mediaItem = data
    }
    console.log('Got Media Item', state.mediaItem)
  },
  [types.SET_MEDIA_DATA](state, data) {
    switch (data.name) {
      case 'name': {
        state.mediaItem.name = data.value
        break
      }
      case 'orgId': {
        state.mediaItem.org_id = parseInt(data.value)
        break
      }
      case 'componentId': {
        state.mediaItem.component_id = parseInt(data.value)
        break
      }
      case 'url': {
        state.mediaItem.url = data.value
        break
      }
      case 'duration': {
        state.mediaItem.duration = parseInt(data.value)
        break
      }
      case 'priority': {
        state.mediaItem.priority = data.value
        break
      }
      case 'start_date': {
        state.mediaItem.start_date = data.value
        break
      }
      case 'end_date': {
        state.mediaItem.end_date = data.value
        break
      }
    }
  },
  [types.SET_MEMBER_STATUS](state, data) {
    state.memberStatus = null
    if (data !== undefined && data !== null) {
      state.memberStatus = data
    }
    console.log('Got Member Component Status', state.memberStatus)
  },
}
